module.exports = __webpack_public_path__ + "static/media/exchange-white.68af2cb6.svg";